import { Theme } from '@mui/material';

export const sxStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    flex: '0 0 30%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      gap: '1rem',
    },
  }),
  cardWrap: (theme: Theme) => ({
    width: '31%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
};
